// extracted by mini-css-extract-plugin
export default {"box":"small-loader_box__nGbk3"};